<template>
  <el-drawer :visible.sync="visible" title="任务列表" :size="1380" class="import-export-page_drawer"
    :destroy-on-close="true" @closed="closed">
    <el-divider></el-divider>

    <div class="import-export-container">
      <!-- 左侧分类 -->
      <div class="left-menu">
        <div class="notify-menu">
          <template v-for="(item, index) in typeList">
            <div v-if="item.children && item.children.length > 0" :key="item.title + index" class="menu-group">
              <div class="menu-group-title" :class="{ active: activeType === item.title }"
                @click="handleTypeSelect(item.title)">
                <span>
                  {{ item.title }}
                </span>
              </div>
            </div>
            <div v-else :key="'menu-' + item.title + index" class="menu-item"
              :class="{ active: activeType === item.title }" @click="handleTypeSelect(item.title)">
              <span>
                {{ item.title }}
                <el-badge :hidden="index == 0 ? importNum <= 0 : exportNum <= 0" :max="99"
                  :value="index == 0 ? importNum : exportNum" class="dot" />
              </span>
            </div>
          </template>
        </div>
      </div>

      <!-- 右侧内容区 -->
      <div class="right-content">
        <ImportExportTable v-show="activeType === '导入任务'" ref="ImportTable" :active-type="activeType"
          :operation-type="0" :list-data="importObj" />
        <ImportExportTable v-show="activeType === '导出任务'" ref="ExportTable" :active-type="activeType"
          :operation-type="1" :list-data="exportObj" />
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { apiGetCurrentTask, apiGetExportEnumList, apiGetCurrentTaskCount } from "@/api/user"
import store from "@/store"
import ImportExportTable from "./ImportExportTable"
import { _bus } from "@/utils/index"
import { apiExportPage } from "@/api/user"

export default {
  name: "ImportExportPage",
  components: { ImportExportTable },
  data() {
    return {
      visible: false,
      tableHeight: 700,
      activeType: "导入任务",
      notifications: [],
      typeList: [],
      enumList: {},
      importNum: 0,
      exportNum: 0,
      importObj: {},
      exportObj: {},
      hasImportTask: false,
      hasExportTask: false
    }
  },

  watch: {
    visible: {
      async handler(val) {
        if (val) {
          await this.getCurrentTask()
          await this.getCurrentTaskCount()
          await this.getExportList(0)
          await this.getExportList(1)
          if (this.hasImportTask) {
            this.activeType = "导入任务"
          } else if (!this.hasImportTask && this.hasExportTask) {
            this.activeType = "导出任务"
          } else {
            this.activeType = "导入任务"
          }
        } else {
          store.dispatch("user/getCurrentTask")
        }
      },
      immediate: true
    }
  },
  created() { },
  mounted() {
    _bus.$on("changeActiveType", this.changeActiveTypeFn)
  },
  methods: {
    // 获取
    async getExportList(val) {
      const params = {
        current: 1,
        size: 10,
        param: {
          operationType: val
        }
      }
      try {
        const res = await apiExportPage(params)
        if (val == 0) {
          this.importObj = res.data
          // 根据实际数据判断是否有导入任务
          this.hasImportTask = res.data && res.data.records && res.data.records.length > 0
        } else {
          this.exportObj = res.data
          // 根据实际数据判断是否有导出任务
          this.hasExportTask = res.data && res.data.records && res.data.records.length > 0
        }
      } catch (error) {
        console.error("获取任务列表失败:", error)
        if (val == 0) {
          this.importObj = {}
          this.hasImportTask = false
        } else {
          this.exportObj = {}
          this.hasExportTask = false
        }
      }
    },
    changeActiveTypeFn(val) {
      const type = val.actionType == "import" ? "导入任务" : "导出任务"
      this.activeType = type
    },
    handleTypeSelect(title) {
      this.activeType = title
      if (this.activeType == "导入任务") {
        this.$refs.ImportTable.fetchData()
      } else {
        this.$refs.ExportTable.fetchData()
      }
    },

    getExportEnumList() {
      if (this.enumList && Object.keys(this.enumList).length > 0) {
        return
      }
      apiGetExportEnumList().then(res => {
        this.enumList = res.data
      })
    },

    getCurrentTaskCount() {
      apiGetCurrentTaskCount().then(res => {
        const { importNum, exportNum } = res.data
        this.importNum = importNum || 0
        this.exportNum = exportNum || 0
      })
    },

    // 获取类型
    getCurrentTask() {
      // 对数据进行归类，分为导入任务，导出任务，系统
      const typeList = []
      const allObj = {
        title: "导入任务",
        sysIds: [],
        unreadCount: 0
      }
      const businessObj = {
        title: "导出任务",
        sysIds: [],
        unreadCount: 0,
        children: []
      }

      typeList.push(allObj)
      typeList.push(businessObj)
      this.typeList = typeList
      return new Promise(resolve => {
        apiGetCurrentTask().then(res => {
          resolve()
        })
      })
    },

    closed() { }
  }
}
</script>

<style>
.import-export-page_drawer .el-drawer__header {
  margin-bottom: 0 !important;
  margin-bottom: 0;
  /* 双重声明提高优先级 */
}

.import-export-page_drawer .el-drawer__header span {
  font-size: 16px;
  font-weight: 700;
  color: rgba(51, 51, 51, 1);
}

.import-export-page_drawer .el-divider {
  margin-bottom: 0;
  margin-top: 18px;
}

.import-export-page_drawer .el-drawer__body {
  overflow: hidden;
}

.single-table-container {
  ::v-deep .el-table__row td {
    padding: 11px 0;
  }
}
</style>

<style scoped lang="scss">
.import-export-container {
  display: flex;
  height: 100%;
  padding-top: 0;
}

.left-menu {
  width: 220px;
  border-right: 1px solid #eee;
  height: 100%;
  flex-shrink: 0;
  padding-top: 20px;
}

.right-content {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.notify-page_list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.notify-item {
  border-bottom: 1px solid #eee;
  padding: 12px;
}

.notify-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;

  .read-hander {
    cursor: pointer;
    font-size: 14px;
    color: #409eff;
  }
}

.notify-title {
  font-weight: bold;
}

.notify-time {
  color: #999;
  font-size: 14px;
}

.notify-content {
  color: #666;
  margin-bottom: 8px;

  ::v-deep img {
    max-width: 300px !important;
  }
}

.notify-footer {
  display: flex;
  justify-content: flex-end;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 左侧菜单样式 */
.notify-menu {
  padding: 16px 0;
  height: 100%;
  overflow-y: auto;
  padding-top: 0;
}

.menu-item {
  padding: 13px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;

  span {
    position: relative;

    .dot {
      position: absolute;
      right: -32px;
      top: 5px;
    }
  }
}

.menu-item:hover {
  background-color: #f5f7fa;
}

.menu-item.active,
.menu-group-title.active {
  background-color: #ecf5ff;
  color: #409eff;
}

.menu-group {
  border-bottom: 1px solid #eee;
  margin: 8px 0;
}

.menu-group-title {
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.1s;
  font-weight: 500;
}

.menu-group-title:hover {
  background-color: #f5f7fa;
}

.menu-group-items {
  background-color: #fafafa;
}

.menu-group-items .menu-item {
  padding-left: 40px;
  font-size: 13px;
}

.block-container {
  position: relative;
  width: 100%;
  display: flex;
}

.el-button--text {
  display: inline-block;
}

.el-button--text:hover {
  background: transparent !important;
  border-color: transparent !important;
}
</style>
